import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AccentDescription, SignActiveStatusDescription, StatusDescription } from '../../../styled'
import { TextWrapper } from '../../styled'
import PermissionCheck from 'views/components/PermissionCheck/PermissionCheck'
import { AButton } from 'views/components/Analytics'
import { SignBodyProps } from '../types'
import { useAProgress } from 'hooks/useAProgress'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { ApprovalStatus } from 'modules/domain/deal/types'

export const ApprovedByCommercialDirector: FC<SignBodyProps> = ({ isDone, deal, dealRefetch }) => {
  const { t } = useTranslation('deal')

  const [, signHandler] = useAProgress(
    () =>
      apiClient.post(endpoints.dealChangeApprovalStatus(deal.id), {
        new_approval_status: ApprovalStatus.APPROVED_BY_COMMERCIAL_DIRECTOR,
      }),
    { eventName: 'approved_by_director', onSuccess: () => dealRefetch() },
  )

  if (isDone) {
    return (
      <TextWrapper>
        <StatusDescription $isDone={isDone}>
          {t('contractSign.status')}{' '}
          <AccentDescription $isDone={isDone}>{t('contractSign.statusSigned')}</AccentDescription>
        </StatusDescription>
      </TextWrapper>
    )
  }

  return (
    <>
      <SignActiveStatusDescription $isDone={isDone}>
        {t('contractSign.waitingCommercialSign')}
      </SignActiveStatusDescription>
      <PermissionCheck scope={['deals.commercial_director_approval']}>
        <AButton id="contractSign" onClick={signHandler} color="primary" size="medium">
          {t('contractSign.sign')}
        </AButton>
      </PermissionCheck>
    </>
  )
}
